import axios from "axios"
import baseURL from "../config/api"

export const post_User = (data: any, token: string) => {
    return axios({
        url: `${baseURL}users`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_User = (data: any, token: string) => {
    return axios({
        url: `${baseURL}users`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_User = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}users`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const getUsers = (token: string) => {
    return getFetch("users", token)
}

export const getUser = (primaryKey: string, token: string) => {
    return getFetch(`users/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}